import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import LoaderIcon from '../../assets/icons/loader-icon';

type LoaderProps = {
  className?: string;
  iconClassName?: string;
};

const Loader: FC<LoaderProps> = ({ className, iconClassName }) => (
  <div
    className={twMerge(
      'flex h-full w-full items-center justify-center max-lg:absolute max-lg:-ml-6 max-lg:-mt-12',
      className,
    )}
  >
    <LoaderIcon className={twMerge('size-16', iconClassName)} />
  </div>
);

export default Loader;
